<template>
  <div class="cardWrap clearfix">
    <div class="cardText clearfix card-background">
      <div class="cardText clearfix cardLine">
        <!-- checkBox -->
        <div style="float: left">
          <slot />
        </div>
        <div class="logoAndStar clearfix">
          <!-- <div v-if="baseData.logoPath" class="logo"><img :src="repliceHttps(baseData.logoPath)" alt="" srcset="" @error.once="baseData.logoPath = null"></div>
          <div v-else :class="['logo2',{'aliasLineHeight': aliasLineHeight}]" :style="'background:'+ backgroundColor">{{setLineHeight(baseData.alias)}}</div> -->
        </div>
        <div class="details">
          <div style="display: flex">
            <div class="clearfix img-box" :class="baseData.source === 'douyin' ? 'img-box-dy': 'img-box-ks'" style="flex">
              <i class="iconfont icon-duanshipin"></i>
            </div>
            <div>
              <div class="nameWrap mb-10">
                <span class="name">{{ baseData.nickName }}</span>
                <!-- <div class="star ml-10">
                  <div class="bg unstar" v-if="baseData.isCollect === '0'" @click.stop="handleStarB(baseData)"></div>
                  <div class="bg" v-else @click.stop="unHandleStarB(baseData)"></div>
                </div> -->
              </div>
              <div v-if="baseData.source || baseData.constellation" class="nameWrap mb-10">
                <span v-if="baseData.source" class="tag platform" :class="baseData.source === 'douyin' ? 'platform-dy': 'platform-ks'">{{ baseData.source === 'douyin' ? 'DY' : 'KS' }}</span>
                <span v-if="baseData.constellation !== '0'&&baseData.constellation!==null" class="tag constellation">{{ constellation(baseData.constellation) }}</span>
              </div>
              <dl class="text">
                <dd class="mr-10">
                  <div class="textOverflow">
                    <span>评论时间：</span> <span>{{ $moment(baseData.createTime * 1000).format('YYYY-MM-DD') }}</span>
                  </div>
                  <div class="textOverflow">
                    <span>关键词内容：</span><span>{{ baseData.keyWord || '--' }}</span>
                  </div>
                </dd>
                <dd class="mr-10">
                  <div class="textOverflow">
                    <span>评论点赞数：</span>
                    <span>{{baseData.awemeCount || 0}}</span>
                  </div>
                </dd>
              </dl>
              <div class="address textOverflow">
                <span>视频源地址：</span>
                <el-tooltip class="item" effect="dark" v-if="baseData.comDesc&&baseData.comDesc.length > 35" :content="baseData.comDesc" placement="top">
                  <a :href="baseData.videoUrl" referrerpolicy="no-referrer" target="_blank">{{ baseData.comDesc }}</a>
                </el-tooltip>
                <a v-else :href="baseData.videoUrl || ''" referrerpolicy="no-referrer" target="_blank">{{ baseData.comDesc || '--' }}</a>
              </div>
              <div class="inquiry-content">
                <div class="tRecommend">
                  <div class="left">
                    <span>询盘内容</span>
                  </div>
                  <div class="text2 textOverflow" style="margin-left: 10px; width: 100%;">
                    <el-tooltip style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" class="item" effect="dark" v-if="baseData.text&&baseData.text.length > 25" :content="baseData.text" placement="top">
                      <span>{{baseData.text}}</span>
                    </el-tooltip>
                    <span v-else>{{baseData.text || '--'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btns">
          <el-button type="primary" size="mini" v-interestExpire @click.stop="immediatelyUnlock(baseData)" v-if="baseData.isUnlock === '0'" class="small-drawer-btn" style="margin-top: 70px;background: #4F7AFD">立即解锁</el-button>
          <el-button type="warning" size="mini" @click.stop="checkDetails(baseData)" v-else class="small-drawer-btn" style="margin-top: 70px;background: #e9ab59">查看详情</el-button>
        </div>
      </div>
      <!-- <div class="btns">
        <el-button v-if="baseData.unlock" type="warning" size="mini" @click.stop="lookNumber" class="small-drawer-btn">查看号码</el-button>
        <el-button v-else type="primary" size="mini" @click.stop="lookNumber" class="small-drawer-btn">立即解锁</el-button>
        <div class="btn-tip" v-if="baseData.receive">已转化</div> -->
        <!-- <template v-else>
          <div class="btn-tip" v-if="baseData.contactCount">手机号码<span class="">{{baseData.contactCount.countMap ?  baseData.contactCount.countMap[1] || 0 : 0}}</span>条</div>
        </template> -->
      <!-- </div> -->
    </div>
    <!-- 查看号码抽屉 -->
    <companyListDrawer ref="vNumber" :companyStatus="inquiryData" :waiting="waiting" @refreshList="contactList" @lookNumber="lookNumberInner" />
  </div>
</template>
<script>
import { parseTime, debounce } from '@/base/global'
import { mapState } from 'vuex'
import { uninterested, contactList, contactCount } from '@/views/clue/api/newClueApi'
import companyListDrawer from './companyListDrawer'

export default {
  name: 'companyList',
  components: {
    companyListDrawer
  },
  props: {
    // 智能推荐栏
    showRecommend: {
      type: Boolean,
      default: true
    },
    // 小T
    xiaoT: {
      type: Boolean,
      default: false
    },
    // 基本数据
    baseData: {
      type: Object,
      default () {
        return {
          base: '上海', // 地区推荐
          name: '小米1',
          legalPersonName: '王川王川', // legalPersonName
          regCapital: '13000万美元', // regCapital
          createTime: '2010-08-25', // createTime
          regStatus: '在业',
          // city: '上海上海上海上海',//
          regLocation: '北京市海淀区西二旗中路33号院6号楼9层019号', // ，
          star: false,
          unlock: false,
          contactCount: {}
        }
      }
    },
    inquiryData: {
      type: Object,
      default: () => {
        return {
          nickName: '卖女孩的小火柴',
          source: 'douyin',
          constellation: '天蝎座',
          uniqueId: 'bug高级工程师',
          createTime: '2022-03-14',
          awemeCount: '20',
          signature: '天不生我李淳罡，剑道万古如长夜',
          comDesc: '空压机#生产厂家#工厂实拍',
          keyWord: '上海机械',
          videoUrl: 'https://api-hl.amemv.com/aweme/v1/play/?video_id=v0200fg10000c3p9gtbc77u844at3ur0&line=1&file_id=6721cafb05c04379ade12ce4f8a3a7a5&sign=cb25dbd96afc3b2172f5354021623248&is_play_url=1&source=PackSourceEnum_SEARCH',
          text: '变频器哪个厂家的，怎么卖'
        }
      }
    }
  },
  data () {
    return {
      feedBack: ['行业不符合', '地区不符合', '号码质量差', '其他原因'],
      checkList: [],
      visible: false,
      aliasLineHeight: false,
      // bgColor: ['#8ca3cd', "#c8b7d8", '#90cfb7', '#ae98c6', '#8ca3cc', '#e79178', '#adddf3', '#f56c6c', '#5daf34'],
      bgColor: ['#7DB3D9', '#84CAB0', '#8CA3CD', '#BC9EDD'],
      waiting: false,
      numberData: [],
      drawer: false,
      companyStatus: {
        companyName: '',
        name: '',
        lockStatus: false,
        contactCount: {}
      }
    }
  },
  watch: {
    // 联系方式次数查询之后设置
    'baseData.contactCount': {
      immediate: true,
      handler (val) {
        if (val) {
          this.companyStatus.contactCount = val
        }
      }
    }
  },
  filters: {
    formatTime (val) {
      if (val) {
        if (typeof val === 'string') val = val.replace(/-/ig, '/')
        return parseTime(new Date(val), '{y}-{m}-{d}')
      }
      return '--'
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus
    }),
    regCapital () {
      if (this.baseData.amount === -1) {
        return '--'
      }
      if (this.baseData.registeredCapital && this.baseData.registeredCapital !== '0.0' && this.baseData.unit && this.baseData.currency) {
        return this.baseData.registeredCapital + this.baseData.unit + this.baseData.currency
      }
      return '--'
    },
    staffSize () {
      const staffSize = this.baseData.staffSize
      if (staffSize) {
        if (staffSize.endsWith('人')) return staffSize
        return staffSize + '人'
      }
      return '--'
    },
    companyWeb () {
      if (!this.baseData.websiteList) {
        return false
      }
      if (this.baseData.websiteList.includes(',')) {
        return this.baseData.websiteList.split(',')[0]
      }
      return this.baseData.websiteList
    },
    companyNameColor () {
      return this.baseData.name || this.baseData.companyName
    },
    companyName () {
      return this.removeHtml(this.baseData.name || this.baseData.companyName || this.baseData.unlabeledCompanyName)
    },
    companyAddress () {
      return this.removeHtml(this.baseData.regAddress || this.baseData.regLocation)
    },
    legalPersonName () {
      return this.removeHtml(this.baseData.legalPersonName)
    },
    textTitle () {
      if (this.baseData.similarity) {
        return `${this.baseData.similarValue}，相似度：${(this.baseData.similarity * 10000 / 100).toFixed(2)}% `
      }
      return this.baseData.similarValue
    },
    backgroundColor () {
      return this.bgColor[this.baseData.color]
    },
    address () {
      return this.baseData.regAddress || this.baseData.regLocation
    },
    companyIndustry () {
      if (this.baseData.industry && this.baseData.subIndustry) {
        return this.baseData.industry + '>' + this.baseData.subIndustry
      } else if (this.baseData.industry) {
        return this.baseData.industry
      } else {
        return '--'
      }
    }
  },
  mounted () {
  },
  methods: {
    constellation (val) {
      if (val) {
        if (val == 1) {
          return '白羊座'
        } else if (val == 2) {
          return '金牛座'
        } else if (val == 3) {
          return '双子座'
        } else if (val == 4) {
          return '巨蟹座'
        } else if (val == 5) {
          return '狮子座'
        } else if (val == 6) {
          return '处女座'
        } else if (val == 7) {
          return '天秤座'
        } else if (val == 8) {
          return '天蝎座'
        } else if (val == 9) {
          return '射手座'
        } else if (val == 10) {
          return '摩羯座'
        } else if (val == 11) {
          return '水瓶座'
        } else if (val == 12) {
          return '双鱼座'
        } else {
          return false
        }
      }
    },
    goUrl (url) {
      var newurl = ''
      if (url.indexOf('http:') == -1 && url.indexOf('https:') == -1) {
        newurl = 'http://' + url
        return newurl
      } else {
        return url
      }
    },
    // 联系方式 获取
    async contactCount () {
      try{
             // const { data } = await contactCount([this.removeHtml(this.baseData.name || this.baseData.companyName)])
            const { data } = await contactCount({hids:[this.baseData.hid]})
            this.$set(this.companyStatus, 'contactCount', data[0])
      }catch(e){

      }
     
      // 已解锁，不走埋点接口
      if (this.baseData.unlock) {
        this.contactList()
      }
    },
    handleStarB (obj) {
      this.$emit('handleCollect', obj)
    },
    unHandleStarB (obj) {
      this.$emit('unHandleCollect', obj)
    },
    immediatelyUnlock (obj) {
      this.$refs.vNumber.drawer = true
      this.$emit('immediatelyUnlock', obj)
    },
    checkDetails (obj) {
      this.$refs.vNumber.drawer = true
      this.$emit('checkDetails', obj)
    },
    // 去重
    unique (str) {
      return this.simpleUnique(str.split(',')).join()
    },
    // 简单数组去重
    simpleUnique (array) {
      var result = []
      var hash = {}
      for (var i = 0; i < array.length; i++) {
        var key = (typeof array[i]) + array[i]
        if (!hash[key]) {
          result.push(array[i])
          hash[key] = true
        }
      }
      return result
    },
    titleHandle () {
      Object.assign(this.companyStatus, this.baseData)
      this.companyStatus.companyName = this.companyName
      this.companyStatus.lockStatus = this.baseData.unlock
      this.companyStatus.regAddress = this.companyAddress
      this.companyStatus.legalPersonName = this.legalPersonName
      if (this.surplus < 1 && !this.baseData.unlock) {
        this.$store.dispatch('PERMISSION_CONFIRM')
        return
      }
      this.showDrawer(this.baseData.unlock)
    },
    // lock=true 解锁
    showDrawer (lock) {
      if (lock) {
        this.contactCount()
        this.companyStatus = { ...this.baseData, legalPersonName: this.legalPersonName, regAddress: this.companyAddress, companyName: this.companyName, lockStatus: true }
      }
      // TODO 废代码
      this.$store.commit('setLastDrawer', this.$refs.vNumber)
      this.$refs.vNumber.drawerTaggle()
    },
    // changeNews() {
    //   this.$emit('changeNews-handle', this.companyName)
    // },
    changeRecommendList () {
      this.$emit('change-recommendList')
    },
    setLineHeight (val) {
      if (val && val.length > 0) {
        const zm = /^[A-Za-z]+$/g
        if (zm.test(val) && val.length < 4) {
          this.aliasLineHeight = true
        } else if (val.length < 3) {
          this.aliasLineHeight = true
        }
      }
      const zz = /[\u4e00-\u9fa5]/g
      if (val) return val.substr(0, 4)
      return this.companyName.match(zz).join('').substr(0, 4)
    },
    lookNumberInner () {
      // 不刷新显示解锁
      this.baseData.unlock = true
      this.$emit('unlock-change')
      this.companyStatus = { ...this.baseData, legalPersonName: this.legalPersonName, regAddress: this.companyAddress, companyName: this.companyName, lockStatus: true }
      this.contactCount()
    },
    removeHtml (str) {
      if (!str) return
      str = str.replace('<<', '@@@').replace('>>>', '>@1@1@1')
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '').replace('@@@', '<<').replace('@1@1@1', '>>')
    },
    lookNumber () {
      if (this.surplus < 1 && !this.baseData.unlock) { // 没有剩余条数则提示
        this.$store.dispatch('PERMISSION_CONFIRM')
      } else {
        // 不刷新显示解锁
        this.baseData.unlock = true
        this.showDrawer(true)
        this.$emit('unlock-change')
      }
    },
    // 解锁  每次触发接口axios里面会有监听，用来改变次数
    async contactList () {
      this.waiting = true
      const res = await contactList({ companyName: this.companyName,hid:this.baseData.hid, similarValue: this.baseData.similarValue, similarity: this.baseData.similarity })
      this.numberData = res.data.map(e => {
        const count = e.sources && e.sources.length
        let contactInfo = e.content
        // todo 领取的电话做特殊处理 下期做erp 和正式的兼容
        if (process.env.NODE_ENV == 'erp-prod' && contactInfo && e.isTurnClue) {
          const arr = contactInfo.split('')
          contactInfo = arr.map((e, i) => {
            if (i > 2 && i < 7) {
              return '*'
            }
            return e
          }).join('')
        }
        return { ...e, contactInfo, count: count, contactInfoReal: contactInfo }
      })
      this.baseData.receive = this.numberData.some(e => e.isTurnClue)
      this.$nextTick(() => {
        this.$refs.vNumber.init()
      })
      this.waiting = false
    },
    sureFeedBack () {
      if (this.checkList.length) {
        this.uninterested(this.companyName, this.checkList.join())
        this.visible = false
        this.checkList = []
      } else {
        this.$message.warning('未选择条件')
      }
    },
    clickEnterprise () {
      const routeUrl = this.$router.resolve({
        path: '/clue/enterprise',
        query: {
          name: this.companyName,
          similarValue: this.baseData.similarValue || '',
          similarity: this.baseData.similarity || ''
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    // async handleStar () {
    //   let type // 1标准资源 2智能推荐
    //   this.baseData.similarValue ? type = 2 : type = 1
    //   let collect // 1收藏 0 取消
    //   this.baseData.star ? collect = 0 : collect = 1
    //   const res = await star({ collect, type, name: this.companyName, similarValue: this.baseData.similarValue, similarity: this.baseData.similarity })
    //   if (res.code === 200) {
    //     if (collect) {
    //       this.$message.success('收藏成功！')
    //     } else {
    //       this.$message.success('取消收藏成功！')
    //     }
    //     this.baseData.star = !this.baseData.star
    //   } else {
    //     this.$message.success(res.message)
    //   }

    //   if (collect) this.changeRecommendList()
    // },
    async uninterested (companyName, reason) {
      await uninterested({ companyName, reason })
      this.$message.success('操作成功')
      this.changeRecommendList()
    }
  }
}
</script>

<style lang="scss" scoped>
.firstTime {
  margin-left: 70px;
  margin-top: 15px;
  color: #409eff;
  > span {
    margin-right: 15px;
    font-size: 12px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mainUrl {
    width: 350px;
  }
}
.sureFeedBack {
  background-color: royalblue;
  color: #fff;
  cursor: pointer;
  width: 40px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  &:hover {
    background-color: #4169e1cf;
  }
}

.cardWrap {
  padding: 20px 130px;
  background-color: #fff;
  // cursor: pointer;
  transition: all 0.3s, height 0s;
  .cardLine {
    padding: 20px 0px;
    border-bottom: 1px solid #f0f2f5;
  }
  // &:hover {
  //   position: relative;
  //   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  // }
  .recommend {
    float: initial;
    margin: 10px 0;
    .tRecommend {
      display: flex;
      float: left;
      // margin-left: 100px;
      height: 24px;
      line-height: 24px;
      border: 1px solid #ecd4c1;
      color: #b68060;
      background-image: url("~@/assets/icon/xtb.png");
      background-size: contain;
      background-repeat: no-repeat;
      // padding-left: 92px;
      padding-right: 12px;
      border-radius: 5px;
      // max-width: 68%;
      .left {
        width: 92px;
        font-size: 0;
        > span {
          font-size: 12px;
          vertical-align: top;
          color: #333;
        }
        > img {
          height: 100%;
          margin-left: 3px;
        }
      }
      .text2 {
        display: flex;
        align-items: flex-end;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        > span {
          display: inline-block;
          font-size: 12px;
          max-width: 328px;

          &:last-child {
            // width: calc(100% - 115px);
            vertical-align: top;
          }
        }
        span i {
          font-size: 14px;
        }
      }
    }
    .rightBtn {
      float: right;
      text-align: right;
      line-height: 24px;
      span {
        display: inline-block;
        color: #f59a23;
        text-decoration-line: underline;
        cursor: pointer;
        margin: 0 10px;
      }
      span:hover {
        color: #dc8b22;
      }
    }
  }
  .recommend-noMargin {
    margin: 0;
  }
  .tm {
    display: inline-block;
    margin-top: 10px;
    margin-left: 70px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    text-align: left;
    color: #666;
    background-color: #fafafa;
    padding: 0 10px;
    border-radius: 5px;
    max-width: calc(100% - 160px - 70px);
    > img {
      margin-right: 5px;
      position: relative;
      top: -1px;
      width: 12px;
    }
    > span {
      font-size: 12px;
    }
  }

  .logoAndStar {
    width: 60px;
    float: left;
    margin-right: 10px;
    .logo {
      float: right;
      width: 60px;
      height: 60px;
      font-size: 0;
      overflow: hidden;
      > img {
        width: 100%;
      }
    }
    .logo2 {
      float: left;
      width: 60px;
      height: 60px;
      padding: 6px;
      background-color: royalblue;
      font-weight: 400;
      color: #fff;
      text-align: center;
      font-size: 21px;
      line-height: 24px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .aliasLineHeight {
      line-height: 48px;
    }
  }
  .details {
    width: calc(100% - 120px - 70px);
    float: left;
    // height: 222px;
    // .logo {
    //   float: left;
    //   width: 60px;
    //   height: 60px;
    //   padding: 6px;
    //   background-color: royalblue;
    //   font-weight: 400;
    //   color: #fff;
    //   text-align: center;
    //   font-size: 21px;
    //   line-height: 24px;
    //   border-radius: 4px;
    //   margin-right: 10px;
    // }
    .aliasLineHeight {
      line-height: 48px;
    }
    .nameWrap {
      .name {
        font-size: 16px;
        font-weight: 400;
        color: #000;
      }
      /deep/ .el-tag {
        position: relative;
        top: -1px;
        margin-left: 10px;
      }
      .star {
        // float: left;
        display: inline-block;
        width: 20px;
        // height: 20px;
        position: relative;
        > div {
          cursor: pointer;
        }
        .bg {
          background-image: url("~@/assets/industry/star2.png");
          background-repeat: no-repeat;
          width: 20px;
          height: 20px;
          background-size: 100%;
          position: relative;
          top: 5px;
        }
        .unstar {
          background-image: url("~@/assets/industry/star.png");
        }
      }
      .playGet {
        display: inline-block;
        margin-left: 10px;
        background-color: #ebb563;
        color: #fff;
        border-radius: 9px;
        padding: 2px 10px;
      }

      .platform {
        display: inline-block;
        width: 60px;
        height: 22px;
        line-height: 22px;
        margin-right: 10px;
        text-align: center;
      }

      .platform-dy {
        background: #ecf5fc;
        color: #51a4e7;
      }

      .platform-ks {
        background: #fcedd8;
        color: #f69a58;
      }

      .constellation {
        display: inline-block;
        width: 60px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background-color: #f3f3fa;
      }
    }

    .tags {
      span {
        margin-right: 10px;
      }
      .loadingBtn {
        padding: 0px 5px;
        margin-right: 10px;
        line-height: 18px;
        font-size: 12px;
        background-color: #fdf6ec;
        border-color: #faecd8;
        color: #e6a23c;
      }
    }
    span {
      font-size: 12px;
    }
    .text {
      text-align: left;
      margin-bottom: -4px;
      dd {
        font-size: 12px;
        display: inline-block;
        > div {
          margin-bottom: 12px;
        }
        span:nth-child(2) {
          color: #333;
        }
        &:nth-child(1) {
          min-width: 140px;
          max-width: 280px;
        }
        &:nth-child(2) {
          width: 210px;
        }
        &:nth-child(3) {
          max-width: 355px;
        }
      }
      dt {
        display: inline-block;
        margin: 0 20px;
      }
      span {
        color: #999;
      }
    }
    .address {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #999;
      span:nth-child(2) {
        color: #333;
      }

      a {
        font-size: 12px;
        color: #4f7afd;
      }
    }
    .inquiry-content {
      float: initial;
      margin: 10px 0;
      .tRecommend {
        display: flex;
        float: left;
        height: 24px;
        line-height: 24px;
        background-color: #fafafa;
        background-size: contain;
        background-repeat: no-repeat;
        padding-right: 12px;
        border-radius: 5px;
        .left {
          width: 92px;
          font-size: 0;
          background-color: #e9f1ff;
          text-align: center;
          > span {
            font-size: 12px;
            vertical-align: top;
            color: #333;
            color: #4f7afd;
          }
        }
        .text2 {
          display: flex;
          align-items: flex-end;
          height: 22px;
          line-height: 22px;
          font-size: 12px;
          > span {
            display: inline-block;
            font-size: 12px;
            max-width: 328px;

            &:last-child {
              // width: calc(100% - 115px);
              vertical-align: top;
            }
          }
          span i {
            font-size: 14px;
          }
        }
      }
    }

    .img-box {
      width: 60px;
      height: 60px;
      margin-right: 20px;
      text-align: center;
      border-radius: 8px;
      i {
        line-height: 60px;
        font-size: 40px;
      }
    }

    .img-box-dy {
      background: #ebf0fe;
      i {
        color: #4f7afd;
      }
    }

    .img-box-ks {
      background: #fcedd8;
      i {
        color: #ffa72e;
      }
    }

    .textOverflow {
      width: 500px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .btns {
    float: right;
    // text-align: right;
    // width: 108px;
    .el-button {
      margin-top: 65px;
      margin-bottom: 0;
    }
    .btn-tip {
      line-height: 30px;
      color: #666;
      text-align: center;
      font-size: 12px;
      span {
        padding: 0 2px;
        color: #409eff;
      }
    }
  }
}
</style>
